/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './authManageProfile.defs.js'
export { main as default } from './authManageProfile.defs.js'
